// src/components/common/ConfirmDialog.jsx
import * as React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Stack
} from '@mui/material';

function stopAll(e) {
  e.preventDefault?.();
  e.stopPropagation?.();
}

export default function ConfirmDialog({
  open,
  title = 'Подтверждение',
  description,
  confirmText = 'Подтвердить',
  cancelText = 'Отмена',
  onConfirm,
  onCancel,
  confirmColor = 'error',
}) {
  return (
    <Dialog
      open={open}
      onClose={(e, reason) => {
        // закрывать можно, но событию наружу — нет
        stopAll(e);
        onCancel?.(e, reason);
      }}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: { borderRadius: 3 },
        // стопаем события на самом «листе» диалога
        onClick: stopAll,
        onMouseDown: stopAll,
        onTouchStart: stopAll,
        onKeyDown: (e) => {
          // Enter/Space тоже не должны триггерить карточку
          stopAll(e);
        },
        'data-interactive': 'true',
      }}
      // стопаем клик по бэкдропу, чтобы не пробивался в карточку
      BackdropProps={{
        onClick: stopAll,
        onMouseDown: stopAll,
        onTouchStart: stopAll,
        'data-interactive': 'true',
      }}
      // подстрахуемся и на корневом контейнере
      onClick={stopAll}
      onMouseDown={stopAll}
      onTouchStart={stopAll}
      onKeyDown={stopAll}
      data-interactive="true"
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h6">{title}</Typography>
      </DialogTitle>

      {description && (
        <DialogContent sx={{ pt: 0 }}>
          <Typography variant="body1" color="text.secondary">
            {description}
          </Typography>
        </DialogContent>
      )}

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Stack direction="row" spacing={1} data-interactive="true">
          <Button
            onClick={(e) => { stopAll(e); onCancel?.(e); }}
            variant="outlined"
            data-interactive="true"
          >
            {cancelText}
          </Button>
        <Button
            onClick={(e) => { stopAll(e); onConfirm?.(e); }}
            variant="contained"
            color={confirmColor}
            autoFocus
            data-interactive="true"
          >
            {confirmText}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
